'use strict';

var jsxRuntime = require('react/jsx-runtime');
require('react');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const ErrorFallback = (props)=>{
    const { children = `A problem occurred while loading the form.` } = props, rest = _object_without_properties_loose(props, [
        "children"
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx("div", _extends({}, rest, {
        children: children
    }));
};

module.exports = ErrorFallback;
